import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import SizePropType from '../../prop-types/Size';
import styles from './modal.css';
var sizeToClass = {
  xs: styles.xs,
  sm: styles.sm,
  lg: styles.lg,
  xl: styles.xl
};

var Container =
/*#__PURE__*/
function (_Component) {
  _inherits(Container, _Component);

  function Container() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Container);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Container)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      canAnimate: false
    });

    _defineProperty(_assertThisInitialized(_this), "setOverlayRef", function (ref) {
      _this.overlayRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "handleBackgroundClick", function (e) {
      var bgClickable = _this.props.bgClickable;

      if (e.target === _this.overlayRef && bgClickable) {
        _this.close(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "close", function (e) {
      var closeHandler = _this.props.closeHandler;
      closeHandler(e);
    });

    return _this;
  }

  _createClass(Container, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isShowing = this.props.isShowing;

      if (isShowing !== prevProps.isShowing) {
        this.enableAnimation();
      }
    }
  }, {
    key: "enableAnimation",
    value: function enableAnimation() {
      this.setState({
        canAnimate: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isShowing = _this$props.isShowing,
          size = _this$props.size,
          animated = _this$props.animated,
          padded = _this$props.padded,
          closeIcon = _this$props.closeIcon,
          children = _this$props.children;
      var canAnimate = this.state.canAnimate;
      var classNames = [styles.overlay];

      if (isShowing) {
        classNames.push(styles.open);
      }

      if (animated) {
        classNames.push(styles.animated);

        if (canAnimate) {
          classNames.push(styles.fade);
        }
      }

      if (size && sizeToClass[size]) {
        classNames.push(sizeToClass[size]);
      }

      if (padded) {
        classNames.push(styles.padded);
      }

      return React.createElement("div", {
        ref: this.setOverlayRef,
        className: classNames.length ? classNames.join(' ') : undefined,
        onClick: this.handleBackgroundClick,
        role: "none"
      }, React.createElement("div", {
        role: "dialog",
        "aria-modal": "true",
        className: styles.content
      }, closeIcon && React.createElement("button", {
        type: "button",
        onClick: this.close,
        className: styles.closeIcon
      }, React.createElement(FontAwesomeIcon, {
        icon: faTimes,
        size: "2x"
      })), children));
    }
  }]);

  return Container;
}(Component);

_defineProperty(Container, "propTypes", {
  /** Modal dialog content */
  children: PropTypes.node,

  /** Method executed when the modal is closed */
  closeHandler: PropTypes.func,

  /** Modal size */
  size: SizePropType,

  /** Boolean to indicate if the modal should fade in/out  */
  animated: PropTypes.bool,

  /** Boolean to indicate if the modal dialog should be padded */
  padded: PropTypes.bool,

  /** Boolean to indicate if a close icon should be rendered */
  closeIcon: PropTypes.bool,

  /** Boolean to indicate if clicking the background should close the modal */
  bgClickable: PropTypes.bool,

  /** Boolean to indicate if the modal should be visible */
  isShowing: PropTypes.bool
});

_defineProperty(Container, "defaultProps", {
  children: null,
  closeHandler: function closeHandler() {},
  size: 'md',
  animated: true,
  padded: true,
  closeIcon: true,
  bgClickable: true,
  isShowing: false
});

export { Container as default };